/* ============================================

   ZINNIA COLLECTION REDESIGN JS v5 CLEAN

   - View More AJAX

   - Color circle hover preview

   - Product gallery arrows

   - Forces first image as default

   - Removes duplicate gallery systems

   - Fixes closest is not a function

   ============================================ */

(function () {

  'use strict';

  /* ===============================

     PRODUCT GALLERY

     =============================== */

  function zinniaShowGalleryImage(gallery, index) {

    if (!gallery) return;

    var card = gallery.closest('.zinnia-product-card');

    var images = Array.prototype.slice.call(

      gallery.querySelectorAll('[data-zinnia-gallery-image]')

    );

    if (!card || images.length === 0) return;

    if (index < 0) index = images.length - 1;

    if (index >= images.length) index = 0;

    images.forEach(function (img) {

      img.classList.remove('is-active');

      img.style.opacity = '';

      img.style.visibility = '';

      img.style.zIndex = '';

    });

    var activeImage = images[index];

    activeImage.classList.add('is-active');

    gallery.setAttribute('data-zinnia-current-index', String(index));

    if (index === 0) {

      card.classList.remove('zinnia-gallery-manual-active');

    } else {

      card.classList.add('zinnia-gallery-manual-active');

    }

  }

  function resetZinniaGallery(card) {

    if (!card) return;

    var gallery = card.querySelector('[data-zinnia-card-gallery]');

    if (!gallery) return;

    zinniaShowGalleryImage(gallery, 0);

    card.classList.remove('zinnia-gallery-manual-active');

  }

  function initZinniaProductCardGalleries(root) {

    var scope = root || document;

    var galleries = scope.querySelectorAll('[data-zinnia-card-gallery]');

    galleries.forEach(function (gallery) {

      if (gallery.dataset.zinniaGalleryReady === 'true') return;

      gallery.dataset.zinniaGalleryReady = 'true';

      gallery.setAttribute('data-zinnia-current-index', '0');

      zinniaShowGalleryImage(gallery, 0);

    });

  }

  /* ===============================

     COLOR CIRCLE HOVER PREVIEW

     =============================== */

  function initZinniaColorPreview(root) {

    var scope = root || document;

    var colorCircles = scope.querySelectorAll('.zinnia-product-card__color[data-image-url]');

    colorCircles.forEach(function (circle) {

      if (circle.hasAttribute('data-zinnia-color-init')) return;

      circle.setAttribute('data-zinnia-color-init', 'true');

      circle.addEventListener('mouseenter', function () {

        var card = circle.closest('.zinnia-product-card');

        if (!card) return;

        var img =

          card.querySelector('.zinnia-product-card__gallery-image.is-active') ||

          card.querySelector('.zinnia-product-card__image');

        var newSrc = circle.getAttribute('data-image-url');

        if (!img || !newSrc) return;

        if (!img.hasAttribute('data-original-src')) {

          img.setAttribute('data-original-src', img.getAttribute('src'));

        }

        img.style.opacity = '0.7';

        setTimeout(function () {

          img.setAttribute('src', newSrc);

          img.style.opacity = '1';

        }, 120);

        var siblings = card.querySelectorAll('.zinnia-product-card__color');

        siblings.forEach(function (s) {

          s.classList.remove('is-active');

        });

        circle.classList.add('is-active');

      });

      circle.addEventListener('mouseleave', function () {

        var card = circle.closest('.zinnia-product-card');

        if (!card) return;

        var img =

          card.querySelector('.zinnia-product-card__gallery-image.is-active') ||

          card.querySelector('.zinnia-product-card__image');

        if (!img) return;

        var originalSrc = img.getAttribute('data-original-src');

        if (originalSrc) {

          img.style.opacity = '0.7';

          setTimeout(function () {

            img.setAttribute('src', originalSrc);

            img.style.opacity = '1';

          }, 120);

        }

        var siblings = card.querySelectorAll('.zinnia-product-card__color');

        siblings.forEach(function (s) {

          s.classList.remove('is-active');

        });

        var first = card.querySelector('.zinnia-product-card__color');

        if (first) first.classList.add('is-active');

      });

    });

  }

  /* ===============================

     VIEW MORE AJAX

     =============================== */

  function initViewMore() {

    var btn = document.querySelector('.zinnia-view-more-btn');

    if (!btn) return;

    if (btn.dataset.zinniaViewMoreInitialized === 'true') return;

    btn.dataset.zinniaViewMoreInitialized = 'true';

    btn.addEventListener('click', function (event) {

      event.preventDefault();

      var nextUrl = btn.getAttribute('data-next-url');

      if (!nextUrl) return;

      btn.classList.add('is-loading');

      btn.disabled = true;

      fetch(nextUrl, { credentials: 'same-origin' })

        .then(function (response) {

          if (!response.ok) {

            throw new Error('Network response was not ok');

          }

          return response.text();

        })

        .then(function (html) {

          var parser = new DOMParser();

          var doc = parser.parseFromString(html, 'text/html');

          var newGrid = doc.querySelector('.zinnia-collection-grid');

          var currentGrid = document.querySelector('.zinnia-collection-grid');

          if (!newGrid || !currentGrid) {

            showAllLoaded(btn);

            return;

          }

          var newItems = newGrid.querySelectorAll(':scope > .zinnia-collection-grid__item');

          if (!newItems.length) {

            showAllLoaded(btn);

            return;

          }

          var existingIds = new Set();

          currentGrid.querySelectorAll('.zinnia-product-card[data-product-id]').forEach(function (card) {

            existingIds.add(card.getAttribute('data-product-id'));

          });

          var addedCount = 0;

          newItems.forEach(function (item) {

            var productCard = item.querySelector('.zinnia-product-card[data-product-id]');

            if (productCard) {

              var pid = productCard.getAttribute('data-product-id');

              if (existingIds.has(pid)) {

                return;

              }

              existingIds.add(pid);

            }

            currentGrid.appendChild(item.cloneNode(true));

            addedCount++;

          });

          if (addedCount === 0) {

            showAllLoaded(btn);

            return;

          }

          var newBtn = doc.querySelector('.zinnia-view-more-btn');

          if (newBtn && newBtn.getAttribute('data-next-url')) {

            btn.setAttribute('data-next-url', newBtn.getAttribute('data-next-url'));

            var newPage = newBtn.getAttribute('data-current-page');

            if (newPage) {

              btn.setAttribute('data-current-page', newPage);

            }

            btn.classList.remove('is-loading');

            btn.disabled = false;

          } else {

            showAllLoaded(btn);

          }

          initZinniaProductCardGalleries(currentGrid);

          initZinniaColorPreview(currentGrid);

        })

        .catch(function (error) {

          console.error('Zinnia View More error:', error);

          btn.classList.remove('is-loading');

          btn.disabled = false;

        });

    });

  }

  function showAllLoaded(btn) {

    var wrapper = btn.parentElement;

    if (wrapper) {

      wrapper.innerHTML = '<p class="zinnia-all-loaded">تم عرض جميع المنتجات</p>';

    }

  }

  /* ===============================

     GLOBAL EVENTS

     =============================== */

  document.addEventListener(

    'click',

    function (event) {

      var target = event.target;

      if (!target || !target.closest) return;

      var nextButton = target.closest('[data-zinnia-gallery-next]');

      var prevButton = target.closest('[data-zinnia-gallery-prev]');

      if (!nextButton && !prevButton) return;

      event.preventDefault();

      event.stopPropagation();

      var button = nextButton || prevButton;

      var gallery = button.closest('[data-zinnia-card-gallery]');

      if (!gallery) return;

      var images = Array.prototype.slice.call(

        gallery.querySelectorAll('[data-zinnia-gallery-image]')

      );

      if (images.length <= 1) return;

      var currentIndex = parseInt(gallery.getAttribute('data-zinnia-current-index') || '0', 10);

      if (isNaN(currentIndex)) currentIndex = 0;

      if (nextButton) {

        zinniaShowGalleryImage(gallery, currentIndex + 1);

      }

      if (prevButton) {

        zinniaShowGalleryImage(gallery, currentIndex - 1);

      }

    },

    true

  );

  document.addEventListener(

    'mouseleave',

    function (event) {

      var target = event.target;

      if (!target || !target.closest) return;

      var card = target.closest('.zinnia-product-card');

      if (!card) return;

      resetZinniaGallery(card);

    },

    true

  );

  /* ===============================

     INIT

     =============================== */

  function init() {

    initViewMore();

    initZinniaProductCardGalleries(document);

    initZinniaColorPreview(document);

  }

  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', init);

  } else {

    init();

  }

  document.addEventListener('shopify:section:load', function () {

    init();

  });

  window.zinniaInitProductCardGalleries = initZinniaProductCardGalleries;

  window.zinniaInitColorPreview = initZinniaColorPreview;

})();